import { Above, PlusIcon, Text, u } from '@ui';

import * as css from './ModuleSelectionItem.css';

export type ModuleSelectionItemProps = {
    label: string;
    category?: string;
} & React.DOMAttributes<HTMLDivElement>;

export const ModuleSelectionItem = ({ label, category, ...props }: ModuleSelectionItemProps) => {
    return (
        <div className={css.moduleSelectionInput} {...props}>
            <div className={css.inputMain}>
                <div className={css.addButton}>
                    <PlusIcon size={u(2)} weight="bold" />
                </div>
                <Text variant="p">{label}</Text>
            </div>
            <Above bp="md">
                {category?.length && (
                    <Text variant="label" color="muted">
                        {category}
                    </Text>
                )}
            </Above>
        </div>
    );
};
